import { useRef } from 'react';
import { Menu } from '@base-ui/react/menu';
import { CaretDown, GearSix, Question, ShieldCheck, SignOut } from '@phosphor-icons/react';
import { MenuAction, MenuDivider } from '@kiipu/ui';
import type { User } from '../api';
import { desktopBridge, openSettings, platformState } from '../lib/client-platform';

export function DesktopAccountMenu({ user, onLogout }: { user: User; onLogout: () => void }) {
  const handingOff = useRef(false);
  const initial = Array.from(user.name.trim() || user.email)[0]?.toUpperCase();
  return (
    <Menu.Root
      onOpenChange={(open) => {
        if (open) handingOff.current = false;
      }}
    >
      <Menu.Trigger
        render={
          <button
            type="button"
            className="desktop-account-trigger"
            aria-label={`打开 ${user.name || user.email} 的账户菜单`}
          />
        }
      >
        <span className="avatar">{initial}</span>
        <span className="desktop-account-name">{user.name || user.email.split('@')[0]}</span>
        <CaretDown size={12} />
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Positioner side="top" align="start" sideOffset={8} style={{ zIndex: 100 }}>
          <Menu.Popup
            className="menu-popup desktop-account-popup"
            finalFocus={() => !handingOff.current}
          >
            <div className="desktop-account-summary">
              <span className="avatar">{initial}</span>
              <div>
                <strong>{user.name || user.email}</strong>
                <span>{user.email}</span>
              </div>
            </div>
            <MenuDivider />
            <MenuAction
              onClick={() => {
                handingOff.current = true;
                void openSettings();
              }}
            >
              <GearSix size={15} />
              设置
            </MenuAction>
            <MenuAction
              onClick={() => {
                handingOff.current = true;
                void openSettings('/settings/feedback');
              }}
            >
              <Question size={15} />
              帮助与反馈
            </MenuAction>
            {user.role === 'admin' ? (
              <MenuAction
                onClick={() => {
                  handingOff.current = true;
                  void desktopBridge()?.openExternal(
                    new URL('/admin', platformState()!.apiOrigin).href,
                  );
                }}
              >
                <ShieldCheck size={15} />
                管理后台
              </MenuAction>
            ) : null}
            <MenuDivider />
            <MenuAction onClick={onLogout}>
              <SignOut size={15} />
              退出登录
            </MenuAction>
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  );
}
